export const items = {
  ar: {
    title: 'البنود',
    addNew: 'إضافة جديد',
    search: 'بحث...',
    serial: 'التسلسل',
    name: 'الاسم',
    nameEn: 'الاسم بالإنجليزية',
    barcode: 'الباركود',
    codeItem: 'رمز المنتج',
    category: 'الفئة',
    type: 'النوع',
    cost: 'التكلفة',
    price: 'السعر',
    unit: 'الوحدة',
    tax: 'الضريبة',
    minQuantity: 'أقل كمية',
    maxQuantity: 'أعلى كمية',
    discountPercentage: 'نسبة الخصم',
    isActive: 'نشط',
    actions: 'الإجراءات',
    edit: 'تعديل',
    delete: 'حذف',
    copy: 'نسخ',
    paste: 'لصق',
    view: 'عرض',
    print: 'طباعة',
    export: 'تصدير',
    import: 'استيراد',
    noItems: 'لا توجد بنود',
    loading: 'جاري تحميل البنود...',
    error: 'فشل تحميل البنود',
    saveSuccess: 'تم حفظ البند بنجاح',
    saveError: 'فشل حفظ البند',
    deleteSuccess: 'تم حذف البند بنجاح',
    deleteError: 'فشل حذف البند',
    copySuccess: 'تم نسخ البند',
    pasteSuccess: 'تم لصق البند بنجاح',
    pasteError: 'لا يوجد بند منسوخ',
    selectUnit: 'اختر الوحدة الصغرى',
    searchUnits: 'بحث في الوحدات...',
    addNewUnit: 'إضافة وحدة جديدة',
    new: 'جديد',
    noUnits: 'لا توجد وحدات',
    unitNameAr: 'اسم الوحدة (عربي)',
    unitNameEn: 'اسم الوحدة (إنجليزي)',
    enterUnitNameAr: 'أدخل اسم الوحدة بالعربي',
    enterUnitNameEn: 'أدخل اسم الوحدة بالإنجليزي',
    unitNameRequired: 'اسم الوحدة مطلوب',
    unitAddedSuccess: 'تم إضافة الوحدة واختيارها بنجاح',
    unitAddError: 'فشل إضافة الوحدة',
  },
  en: {
    title: 'Items',
    addNew: 'Add New',
    search: 'Search...',
    serial: 'Serial',
    name: 'Name',
    nameEn: 'Name (English)',
    barcode: 'Barcode',
    codeItem: 'Product Code',
    category: 'Category',
    type: 'Type',
    cost: 'Cost',
    price: 'Price',
    unit: 'Unit',
    tax: 'Tax',
    minQuantity: 'Min Quantity',
    maxQuantity: 'Max Quantity',
    discountPercentage: 'Discount %',
    isActive: 'Active',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    copy: 'Copy',
    paste: 'Paste',
    view: 'View',
    print: 'Print',
    export: 'Export',
    import: 'Import',
    noItems: 'No items',
    loading: 'Loading items...',
    error: 'Failed to load items',
    saveSuccess: 'Item saved successfully',
    saveError: 'Failed to save item',
    deleteSuccess: 'Item deleted successfully',
    deleteError: 'Failed to delete item',
    copySuccess: 'Item copied',
    pasteSuccess: 'Item pasted successfully',
    pasteError: 'No item copied',
    selectUnit: 'Select Smallest Unit',
    searchUnits: 'Search units...',
    addNewUnit: 'Add New Unit',
    new: 'New',
    noUnits: 'No units found',
    unitNameAr: 'Unit Name (Arabic)',
    unitNameEn: 'Unit Name (English)',
    enterUnitNameAr: 'Enter unit name in Arabic',
    enterUnitNameEn: 'Enter unit name in English',
    unitNameRequired: 'Unit name is required',
    unitAddedSuccess: 'Unit added and selected successfully',
    unitAddError: 'Failed to add unit',
  },
  fr: {
    title: 'Articles',
    addNew: 'Ajouter nouveau',
    search: 'Rechercher...',
    serial: 'Série',
    name: 'Nom',
    nameEn: 'Nom (anglais)',
    barcode: 'Code-barres',
    codeItem: 'Code produit',
    category: 'Catégorie',
    type: 'Type',
    cost: 'Coût',
    price: 'Prix',
    unit: 'Unité',
    tax: 'Taxe',
    minQuantity: 'Qté min',
    maxQuantity: 'Qté max',
    discountPercentage: 'Remise %',
    isActive: 'Actif',
    actions: 'Actions',
    edit: 'Modifier',
    delete: 'Supprimer',
    copy: 'Copier',
    paste: 'Coller',
    view: 'Voir',
    print: 'Imprimer',
    export: 'Exporter',
    import: 'Importer',
    noItems: 'Aucun article',
    loading: 'Chargement des articles...',
    error: 'Échec du chargement des articles',
    saveSuccess: 'Article enregistré avec succès',
    saveError: 'Échec de l\'enregistrement de l\'article',
    deleteSuccess: 'Article supprimé avec succès',
    deleteError: 'Échec de la suppression de l\'article',
    copySuccess: 'Article copié',
    pasteSuccess: 'Article collé avec succès',
    pasteError: 'Aucun article copié',
    selectUnit: 'Sélectionner la plus petite unité',
    searchUnits: 'Rechercher des unités...',
    addNewUnit: 'Ajouter une nouvelle unité',
    new: 'Nouveau',
    noUnits: 'Aucune unité',
    unitNameAr: 'Nom de l\'unité (arabe)',
    unitNameEn: 'Nom de l\'unité (anglais)',
    enterUnitNameAr: 'Entrez le nom de l\'unité en arabe',
    enterUnitNameEn: 'Entrez le nom de l\'unité en anglais',
    unitNameRequired: 'Le nom de l\'unité est requis',
    unitAddedSuccess: 'Unité ajoutée et sélectionnée avec succès',
    unitAddError: 'Échec de l\'ajout de l\'unité',
  },
}


